import { render } from "./ScoreEntryBox.vue?vue&type=template&id=5f9852c4&scoped=true"
import script from "./ScoreEntryBox.vue?vue&type=script&lang=js"
export * from "./ScoreEntryBox.vue?vue&type=script&lang=js"

import "./ScoreEntryBox.vue?vue&type=style&index=0&id=5f9852c4&scoped=true&lang=css"

import exportComponent from "/Users/dgorski/tenball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9852c4"]])

export default __exports__